import { ReactElement } from 'react';

import withIcon from '../withIcon';

const Psychology = (): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512.000000 512.000000"
    >
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          d="M2023 5105 c-338 -43 -673 -180 -947 -388 -104 -78 -284 -259 -362
-362 -393 -519 -506 -1182 -305 -1794 53 -161 118 -294 249 -508 354 -579 518
-1112 548 -1783 8 -181 20 -217 84 -250 38 -20 57 -20 820 -20 763 0 782 0
820 20 50 25 75 74 84 158 9 94 33 165 77 232 67 100 172 174 280 199 25 6
191 11 382 11 319 0 340 1 377 20 26 13 47 34 60 60 19 37 20 58 20 355 l0
315 -240 0 c-222 0 -244 2 -280 20 -45 23 -80 80 -80 130 0 50 35 107 80 130
36 18 58 20 292 20 l253 0 30 58 c73 140 237 242 392 242 75 0 153 76 153 149
0 18 -7 46 -17 64 -9 18 -144 229 -300 469 l-283 437 0 172 c0 143 -4 192 -25
294 -100 497 -403 942 -840 1235 -103 69 -296 168 -410 209 -110 40 -259 78
-380 97 -136 21 -400 26 -532 9z m607 -905 c65 -33 74 -62 80 -241 l5 -156
130 73 c109 63 136 74 176 74 83 0 97 -16 276 -325 89 -154 165 -295 169 -313
9 -46 -11 -106 -44 -134 -15 -13 -78 -52 -140 -88 -62 -35 -112 -67 -112 -70
0 -3 50 -35 112 -70 62 -36 125 -75 140 -88 33 -28 53 -88 44 -134 -4 -18 -80
-159 -169 -313 -179 -309 -193 -325 -276 -325 -40 0 -67 11 -176 74 l-130 73
-5 -156 c-6 -179 -15 -208 -80 -241 -37 -19 -58 -20 -370 -20 -312 0 -333 1
-370 20 -65 33 -74 62 -80 241 l-5 156 -130 -73 c-109 -63 -136 -74 -176 -74
-83 0 -97 16 -276 325 -89 154 -165 295 -169 313 -9 46 11 106 44 134 15 13
78 52 140 88 62 35 112 67 112 70 0 3 -50 35 -112 70 -62 36 -125 75 -140 88
-33 28 -53 88 -44 134 4 18 80 159 169 313 179 309 193 325 276 325 40 0 67
-11 176 -74 l130 -73 5 156 c6 178 15 208 78 240 35 19 58 20 370 21 314 0
335 -1 372 -20z"
        />
        <path
          d="M2108 3786 c-3 -118 -6 -138 -24 -163 -21 -28 -106 -83 -201 -129
-68 -33 -93 -28 -223 46 l-104 59 -53 -90 c-82 -141 -97 -169 -92 -172 2 -2
45 -27 94 -55 152 -86 167 -109 159 -253 -10 -179 -16 -190 -157 -270 -51 -29
-94 -54 -96 -56 -5 -3 10 -31 92 -172 l53 -90 104 59 c130 74 155 79 223 46
95 -46 180 -101 201 -129 18 -25 21 -45 24 -163 l4 -134 148 0 148 0 4 134 c3
118 6 138 24 163 21 28 106 83 201 129 68 33 93 28 223 -46 l104 -59 53 90
c82 141 97 169 92 172 -2 2 -44 27 -94 55 -153 86 -168 110 -159 254 10 179
16 190 157 269 51 29 94 54 96 56 5 3 -10 31 -92 172 l-53 90 -104 -59 c-130
-74 -155 -79 -223 -46 -95 46 -180 101 -201 129 -18 25 -21 45 -24 163 l-4
134 -148 0 -148 0 -4 -134z m274 -494 c59 -26 124 -91 151 -151 30 -64 30
-178 0 -242 -27 -60 -92 -125 -152 -152 -64 -30 -178 -30 -242 0 -129 59 -202
206 -169 342 43 180 242 278 412 203z"
        />
      </g>
    </svg>
  );
};

export default withIcon(Psychology);
